export default {
  cardPack: 'Kartenpaket',
  cardsSuffix: '-Karten',
  notFound: 'Keine Karten gefunden',
  fullCollectionReward: 'Belohnung für volle Sammlung',
  canFind: 'Diese Karte kann in folgenden Paketen gefunden werden',
  cannotFind: 'Diese Karte kann aktuell in keinen Paketen gefunden werden',
  active: 'Aktive Karten',
  equipped: 'Karten angelegt',
  onActive: 'wenn aktiv',
  onDuplicate: 'bei Doppelten',
  activeDescription: 'Doppelte Karten können ausgerüstet werden und werden beim nächsten Prestige verbraucht, um deren Effekte zu aktivieren. Diese Effekte bleiben bis zum folgenden Prestige erhalten.',
  equipTutorial: {
    description: 'Du hast deine ersten Karten gesammelt! Die meisten Karten haben einen Effekt, wenn sie aktiv sind, welcher auf folgende Art genutzt werden kann:',
    1: 'Erhalte eine doppelte Karte',
    2: 'Schalte Prestige für eine deiner Hauptfunktionen frei',
    3: 'Gehe ins Prestigemenü und lege die doppelte Karte an (muss die gleiche Funktion sein wie unten rechts auf der Karte)',
    4: 'Führe einen Prestige mit der angelegten Karte durch',
    5: 'Die Karte wird verbraucht und die Effekt sind bis zum nächsten Prestige aktiv'
  },
  card: {
    'MI-0001': 'Grundlegende Ausrüstung',
    'MI-0002': 'Unbenutzte Spitzhacke',
    'MI-0003': 'Spitzhackenkiste',
    'MI-0004': 'Lunte anzünden!',
    'MI-0005': 'In die Tiefen',
    'MI-0006': 'Helmregal',
    'MI-0007': 'In Deckung!',
    'MI-0008': 'Harte Arbeit',
    'MI-0009': 'Spitzhacke oder Schaufel?',
    'MI-0010': 'Zu klein',
    'MI-0011': 'Motivierter Arbeiter',
    'MI-0012': 'Arbeitsunfall',
    'MI-0013': 'Temporäres Lager',
    'MI-0014': 'Gefüllte Kiste',
    'MI-0015': 'An die Oberfläche',
    'MI-0016': 'Extraktion',
    'MI-0017': 'Transport',
    'MI-0018': 'Qualitätskontrolle',
    'MI-0019': 'Recyclingfabrik',
    'MI-0020': 'Hydraulische Presse',
    'MI-0021': 'Raffinerie-Experiment',
    'MI-0022': 'Roboterbau',
    'MI-0023': 'Feststeckende Spitzhacke',
    'MI-0024': 'Bergwerkeingang',
    'MI-0025': 'Felshaufen sprengen',
    'MI-0026': 'Minenschacht',
    'MI-0027': 'Oberflächenstein',
    'MI-0028': 'Fledermäuse stören',
    'MI-0029': 'Kriechende Krabbler',
    'MI-0030': 'Seltener Fund',
    'MI-0031': 'Unterirdischer See',
    'MI-0032': 'Brennbare Flüssigkeit',
    'MI-0033': 'Unterirdischer Friedhof',
    'MI-0034': 'Lauernde Spinne',
    'MI-0035': 'Kein Entkommen',
    'MI-0036': 'Erdbeben',
    'MI-0037': 'Giftgas',
    'MI-0038': 'Kristallstacheln',

    'VI-0001': 'Massive Felsen',
    'VI-0002': 'Versteckter Edelstein',
    'VI-0003': 'Tropfsteinhöhle',
    'VI-0004': 'Zwei Wege',
    'VI-0005': 'Höhlenblumen',
    'VI-0006': 'Outdoor-Camping',
    'VI-0007': 'Spielplatz',
    'VI-0008': 'Ruhige Gegend',
    'VI-0009': 'Wütender Nachbar',
    'VI-0010': 'Haus mit Garten',
    'VI-0011': 'Häuserbau',
    'VI-0012': 'Campingausflug',
    'VI-0013': 'Wohnzimmer',
    'VI-0014': 'Hundehütte',
    'VI-0015': 'Dachgarten',
    'VI-0016': 'Jahrhundertsbaum',
    'VI-0017': 'Holzdiebstahl',
    'VI-0018': 'Gemeinschafts-Garten',
    'VI-0019': 'Aufforsten',
    'VI-0020': 'Abholzen',
    'VI-0021': 'Holztransporter',
    'VI-0022': 'Forschungslabor',
    'VI-0023': 'Experiment',
    'VI-0024': 'Seuchenanalyse',
    'VI-0025': 'Barren formen',
    'VI-0026': 'Nagelfabrik',
    'VI-0027': 'Alte Bücherei',
    'VI-0028': 'Uhrwerk',
    'VI-0029': 'Kochroboter',
    'VI-0030': 'Ferngesteuerte Garage',
    'VI-0031': 'Generator',
    'VI-0032': 'Solarpanele',
    'VI-0033': 'Selbstfahrendes Auto',
    'VI-0034': 'Feuerwehr',
    'VI-0035': 'Polizeiwache',
    'VI-0036': 'Den Weg leuchten',
    'VI-0037': 'Hunderettung',
    'VI-0038': 'Krankenwagen',
    'VI-0039': 'Rettungsschwimmer',

    'HO-0001': 'Lauernde Schlange',
    'HO-0002': 'Tiefes Loch',
    'HO-0003': 'Ausbrechender Vulkan',
    'HO-0004': 'Verlaufen',
    'HO-0005': 'Ewig gefroren',
    'HO-0006': 'Magmakammer',
    'HO-0007': 'Taschenkontrolle',
    'HO-0008': 'Mauerbau',
    'HO-0009': 'Überwachungs-Kamera',
    'HO-0010': 'Pilzbuch',
    'HO-0011': 'Elektrozaun',
    'HO-0012': 'Megabombe',
    'HO-0013': 'Raketenwerfer',
    'HO-0014': 'Schwerterang',
    'HO-0015': 'Giftpfeil',
    'HO-0016': 'Lenkrakete',
    'HO-0017': 'Axtwerfer',
    'HO-0018': 'Mächtiger Stift',
    'HO-0019': 'Katapult',
    'HO-0020': 'Pistolenschwert',
    'HO-0021': 'Sonnenstrahlen',
    'HO-0022': 'Sägeblattwerfer',
    'HO-0023': 'Supersäure',
    'HO-0024': 'Natürliche Deckung',
    'HO-0025': 'Waldmeditation',
    'HO-0026': 'Metalldetektor',
    'HO-0027': 'Projektilschild',
    'HO-0028': 'Kraftfeld',
    'HO-0029': 'Radar',
    'HO-0030': 'Spion',
    'HO-0031': 'Korruption verboten',
    'HO-0032': 'Flüssigkeitsfilter',
    'HO-0033': 'Waschmaschine',
    'HO-0034': 'Mit Feuer töten',
    'HO-0035': 'Reinigungsstrahl',
    'HO-0036': 'Korruption zerstampfen',
    'HO-0037': 'In den Müll!',
    'HO-0038': 'Seltsames Ritual',
    'HO-0039': 'Staubsauger',
    'HO-0040': 'Macht der Wissenschaft',
    'HO-0041': 'Einfach in die Mikrowelle',

    'FA-0001': 'Äpfel pflücken',
    'FA-0002': 'Kürbiswettbewerb',
    'FA-0003': 'Blumenladen',
    'FA-0004': 'Büropflanze',
    'FA-0005': 'Vogelscheuche',
    'FA-0006': 'Künstlicher Regen',
    'FA-0007': 'Versorgungszug',
    'FA-0008': 'Lebensmittel-Transport',
    'FA-0009': 'Warmes Gewächshaus',
    'FA-0010': 'Fruchtsmoothie',
    'FA-0011': 'Backereiverkauf',
    'FA-0012': 'Eiswagen',
    'FA-0013': 'Fastfood-Bestellung',
    'FA-0014': 'Festmahl',
    'FA-0015': 'Sußigkeitenland',
    'FA-0016': 'Teezeit',
    'FA-0017': 'Weinherstellung',
    'FA-0018': 'Kaffee und Kekse',
    'FA-0019': 'Oranges Gemüse',
    'FA-0020': 'Scharf-fruchtiges Rot',
    'FA-0021': 'Gänseblümchen-Gelb',
    'FA-0022': 'Pflanzengrün',
    'FA-0023': 'Blaubeerbusch',
    'FA-0024': 'Lila Pilze',
    'FA-0025': 'Käferpulver',
    'FA-0026': 'Frische Limette',
    'FA-0027': 'Schmetterlingsflügel',

    'GA-0001': 'Marienkäfer',
    'GA-0002': 'Farbenfrohe Federn',
    'GA-0003': 'Limonade herstellen',
    'GA-0004': 'Algen',
    'GA-0005': 'Kunstmuseum',
    'GA-0006': 'Bleistiftzeichnung',
    'GA-0007': 'Stiftesammlung',
    'GA-0008': 'Sprühgemälde',
    'GA-0009': 'Farbpalette',
    'GA-0010': 'Wandgemälde',
    'GA-0011': 'Unterschrift des Künstlers',
    'GA-0012': 'Farben mischen',
    'GA-0013': 'Moderne Kunstauktion',
    'GA-0014': 'Portrait',
    'GA-0015': 'Abfalleimer',
    'GA-0016': 'Pizzalieferung',
    'GA-0017': 'Paketelieferung',
    'GA-0018': 'Schulbus',
    'GA-0019': 'Farbtrommelfabrik',
    'GA-0020': 'Frachtschiff',
    'GA-0021': 'Umzugsunternehmen',
    'GA-0022': 'Drohnenlieferung',
    'GA-0023': 'Abschleppwagen',

    'GE-0001': 'Rubinbahn',
    'GE-0002': 'Smaragdmine',
    'GE-0003': 'Gesunkener Schatz',
    'GE-0004': 'Luxusuhr',
    'GE-0005': 'Gefährliche Dreiecke',
    'GE-0006': 'Diamantwerkzeuge',
    'GE-0007': 'Sicherheitsmaßnahmen',

    'EV-0001': 'Jahrmarkt',
    'EV-0002': 'Bauwettbewerb',
    'EV-0003': 'Grill',
    'EV-0004': 'Geburtstagsparty',
    'EV-0005': 'Gartenverkauf',
    'EV-0006': 'Tankstelle',
    'EV-0007': 'Händler vor Ort',
    'EV-0008': 'Bingo im Fernsehen',
    'EV-0009': 'Casino',
    'EV-0010': '???',
    'EV-0011': 'Banktresor',
    'EV-0012': 'Profit!',
    'EV-0013': 'Kreditkarte',
    'EV-0014': 'Wüste',
    'EV-0015': 'Paragliding',
    'EV-0016': 'Dschungelrätsel',
    'EV-0017': 'Gestrandete Schildkröte',
    'EV-0018': 'Blumenzucht',
    'EV-0019': 'Pflanzenprobe',
    'EV-0020': 'Speerfischen',
    'EV-0021': 'Schneckenrennen',
    'EV-0022': 'Einsame Insel',
    'EV-0023': 'Sommerlied',
    'EV-0024': 'Gemütliche Couch',
    'EV-0025': 'Ungemütlicher Berg',
    'EV-0026': 'Stadt bei Nacht',
    'EV-0027': 'Heißer Apfelsaft',
    'EV-0028': 'Mysteriöse Suppe',
    'EV-0029': 'Geheime Quelle',
    'EV-0030': 'Schneemann bauen',
    'EV-0031': 'Wintersport',
    'EV-0032': 'Burgbeleuchtung',
    'EV-0033': 'Glühbirnen-Geschäft',

    'XD-1337': 'Testkarte'
  },
  collection: {
    minersAndEquipment: 'Bergleute und Ausrüstung',
    scrapLogistics: 'Schrottlogistik',
    caveLocations: 'Höhlenorte',
    dangersInTheDark: 'Gefahren im Dunkeln',
    neighborhood: 'Nachbarschaft',
    plantsInTheCity: 'Grün in der Stadt',
    industrialRevolution: 'Industrielle Revolution',
    maintainingSafety: 'Sicherheit bewahren',
    dangerousWeapons: 'Gefährliche Waffen',
    supplyAndSupport: 'Helfen und Versorgen',
    againstTheCorruption: 'Gegen die Korruption',
    feedingTheWorld: 'Die Welt ernähren',
    organicDyes: 'Organische Farbe',
    artDisplay: 'Kunstausstellung',
    deliveryService: 'Lieferdienst',
    preciousJewelry: 'Wertvolle Juwelen',
    weekendTrip: 'Wochenendausflug',
    tropicalParadise: 'Tropisches Paradies',
    coldTimes: 'Kalte Zeiten',
  },
  pack: {
    intoDarkness: 'In die Dunkelheit',
    drillsAndDepths: 'Bohrer und Tiefen',
    hotStuff: 'Heißes Zeug',
    dangerZone: 'Gefahrenzone',
    meetingNewPeople: 'Neue Leute treffen',
    darkCult: 'Dunkler Kult',
    technologicalAdvancement: 'Technologischer Fortschritt',
    rookieOnTheBattlefield: 'Neuling auf dem Schlachtfeld',
    spiritualSuccess: 'Spiritueller Erfolg',
    oldMemories: 'Alte Erinnerungen',
    taintedWorld: 'Verdorbene Welt',
    bountifulHarvest: 'Ertragreiche Ernte',
    juicyYields: 'Saftiger Ertrag',
    insectWorld: 'Insektenwelt',
    beesAndFlowers: 'Bienen und Blümchen',
    newArtist: 'Neuer Künstler',
    inspiringCreations: 'Inspirierende Werke',
    goodDeal: 'Guter Tausch',
    connectedLine: 'Verbundene Linie',
    feelingLucky: 'Glücksgefühl',
    investorsDream: 'Investorentraum',
    greenThumb: 'Grüner Daumen',
    fishingForFun: 'Angeln aus Spaß',
    charmingShip: 'Bezauberndes Schiff',
    midnightAnomaly: 'Mitternachtsanomalie',
    icyWonderland: 'Eisiges Wunderland',
    sparksOfJoy: 'Funken der Freude',
  }
};
